module.exports = __webpack_public_path__ + "static/media/1.24837306.JPG";